/* ═══════════════════════════════════════════════
   LES NOBLES ESSENCES — Theme JS
   ═══════════════════════════════════════════════ */

document.addEventListener('DOMContentLoaded', function () {

  /* ── Nav scroll ──────────────────────────────── */
  var nav = document.getElementById('nav');
  var announce = document.querySelector('.announce');
  var announceH = announce ? announce.offsetHeight : 36;

  function onScroll() {
    if (nav) {
      nav.classList.toggle('scrolled', window.scrollY > announceH + 10);
    }
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* ── Hamburger ───────────────────────────────── */
  var burger = document.getElementById('navBurger');
  var navLinks = document.querySelector('.nav-links');
  var overlay = document.getElementById('navOverlay');

  if (burger && navLinks) {
    function toggleMenu(open) {
      burger.classList.toggle('open', open);
      navLinks.classList.toggle('open', open);
      if (overlay) overlay.classList.toggle('open', open);
      burger.setAttribute('aria-expanded', String(open));
      document.body.style.overflow = open ? 'hidden' : '';
    }
    burger.addEventListener('click', function () {
      toggleMenu(!burger.classList.contains('open'));
    });
    if (overlay) {
      overlay.addEventListener('click', function () { toggleMenu(false); });
    }
    document.querySelectorAll('.nav-links a').forEach(function (a) {
      a.addEventListener('click', function () { toggleMenu(false); });
    });
  }

  /* ── Hero video lazy load ─────────────────────── */
  var heroVideo = document.getElementById('heroVideo');
  if (heroVideo) {
    function loadVideo() {
      if (navigator.connection && navigator.connection.saveData) return;
      heroVideo.src = heroVideo.dataset.src;
      heroVideo.play().catch(function () {});
    }
    if (document.readyState === 'complete') {
      setTimeout(loadVideo, 300);
    } else {
      window.addEventListener('load', function () { setTimeout(loadVideo, 300); });
    }
  }

  /* ── Product page: Voir plus ─────────────────── */
  var pdpVoir = document.getElementById('pdpVoir');
  var pdpDesc = document.getElementById('pdpDesc');
  if (pdpVoir && pdpDesc) {
    pdpVoir.addEventListener('click', function () {
      var open = pdpDesc.classList.toggle('open');
      pdpVoir.textContent = open ? 'Voir moins' : 'Voir plus';
    });
  }

  /* ── Product page: Accordéons ────────────────── */
  document.querySelectorAll('.pdp-acc-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var body = btn.nextElementSibling;
      var isOpen = btn.classList.toggle('open');
      if (body) body.classList.toggle('open', isOpen);
      btn.setAttribute('aria-expanded', String(isOpen));
    });
  });

  /* ── Product page: Gallery thumbnails ───────── */
  var gallery = document.getElementById('galleryMain');
  if (gallery) {
    var items = gallery.querySelectorAll('.gallery-img-item');
    var btns = gallery.querySelectorAll('.gallery-nav-btn');

    function setActive(idx) {
      btns.forEach(function (b, i) { b.classList.toggle('active', i === idx); });
    }

    var observer = new IntersectionObserver(function (entries) {
      var best = null;
      entries.forEach(function (e) {
        if (!best || e.intersectionRatio > best.intersectionRatio) best = e;
      });
      if (best && best.intersectionRatio > 0) {
        setActive(parseInt(best.target.dataset.idx, 10));
      }
    }, { threshold: [0, 0.25, 0.5, 0.75, 1] });

    items.forEach(function (el) { observer.observe(el); });

    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var idx = parseInt(btn.dataset.idx, 10);
        if (items[idx]) items[idx].scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  /* ── Product page: Carousel mobile ──────────── */
  var carouselTrack = document.getElementById('carouselTrack');
  var carouselProgress = document.getElementById('carouselProgress');
  if (carouselTrack) {
    function updateProgress() {
      var idx = Math.round(carouselTrack.scrollLeft / carouselTrack.clientWidth);
      if (carouselProgress) {
        carouselProgress.style.transform = 'translateX(' + (idx * 100) + '%)';
      }
    }
    carouselTrack.addEventListener('scroll', updateProgress, { passive: true });
    updateProgress();
  }

  /* ── Product page: Sticky CTA mobile ────────── */
  var productCta = document.querySelector('.product-cta');
  var stickyCta = document.getElementById('stickyCta');
  if (productCta && stickyCta) {
    var stickyObserver = new IntersectionObserver(function (entries) {
      if (window.innerWidth > 640) { stickyCta.style.display = 'none'; return; }
      stickyCta.style.display = entries[0].isIntersecting ? 'none' : 'flex';
      stickyCta.style.flexDirection = 'column';
    }, { threshold: 0 });
    stickyObserver.observe(productCta);
    window.addEventListener('resize', function () {
      if (window.innerWidth > 640) stickyCta.style.display = 'none';
    });
  }

});
